import { render, staticRenderFns } from "./MessageStatuses.vue?vue&type=template&id=60dec297&"
import script from "./MessageStatuses.vue?vue&type=script&lang=js&"
export * from "./MessageStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports